import { Link,useNavigate,useParams } from "react-router-dom";
import React,{useState, useEffect} from "react"
import axios from "axios";
import { schoolsurl } from '../../apis/urls'
import { decode } from "html-entities";
import { $ } from "react-jquery-plugin";

const SchoolProfile =()=> {
	const { id } = useParams();
	const [result,setResult] = useState([]);
	const [resultc,setResultc] = useState([]);
    let navigate = useNavigate();

	const { sid } = useParams();

	let urole = localStorage.getItem('userrole')

	
	useEffect(() => {
		$('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        Listing();
    },[]
    );



	const Listing = () => {
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: schoolsurl+'/'+id,
            timeout: 1000000,
            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            setResult(response.data.data);        
          }).catch((error) =>{ 
            
            console.log('error',error.message)
          });

    }


	let token = "Bearer "+localStorage.getItem('token');
	const instance = axios.create({
        baseURL: schoolsurl,
        timeout: 1000000,
        headers: {'authorization': token}
      });

	const URI = schoolsurl
    const removeAccreditations = (id) => {
        let r = window.confirm("Are you sure you want to delete this School?");
        if(r == true){
        try {

            instance.delete(`${URI}/${id}`).then((response) =>{
                Listing();
                navigate("/school_list")
            }) 
        } catch (error) {
          alert(error)
          console.log(error)
        }
      }
    }


    return(
        <div>

		<aside className="right-side areas">			
			<div className="content-area">  
			
				<div className="page-title-wrpr">
					<div className="page-title-left-column">
						<i className="icon-library1"></i>
						<h2 className="page-title"> <span className="subtitle">School Profile</span> {decode(result?.name)}</h2>
					</div>

					
					<div className="page-rightside-action-column"></div>
				</div>

				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
					<li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
						{
							urole === 'SUPERADMIN'?
							<li className="breadcrumb-item"><Link to="/school_list">Schools</Link></li>
							:null
						}
						<li className="breadcrumb-item active" aria-current="page">School Profile</li>
					</ol>
				</nav>

				
				<div className="tab-wrpr">
					  <ul className="nav nav-tabs">
						<li className="nav-item">
						  <a className="nav-link active" data-toggle="tab" href="#generalinfo">General Information</a>
						</li>
						<li className="nav-item">
						  <a className="nav-link" data-toggle="tab" href="#characteristics">School Characteristics</a>
						</li>
					  </ul>
					  <div className="tab-content">
						
							  <div id="generalinfo" className="containers tab-pane active"><br/>
							  <div className="row tab-section">
								<div className="col-md-4">
									<label>School Name</label>
									<div>{decode(result?.name)}</div>
								</div>
								<div className="col-md-3">
									<label>Address</label>
									<div>{result?.address_1}<br/>
										{result?.city}, {result?.state}<br/>
										{result?.phone}</div>
								</div>
								<div className="col-md-5">
									<label>Address 2</label>
									<div>{result?.address_2}</div>
								</div>
							  </div>
							  
							  <div className="row tab-section">
								<div className="col-md-4">
									<label>City</label>
									<div>{result?.city}</div>
								</div>
								<div className="col-md-3">
									<label>State</label>
									<div>{result?.state}</div>
								</div>
								<div className="col-md-5">
									<label>Zip</label>
									<div>{result?.zip}</div>
								</div>
							  </div>
							  
							  
							  <div className="row tab-section">
								<div className="col-md-4">
									<label>Phone</label>
									<div><a href="tel:404405-2173">{result?.phone}.</a></div>
								</div>
								<div className="col-md-3">
									<label>Fax</label>
									<div><a href="tel:404405-2173">{result?.fax}</a></div>
								</div>
								<div className="col-md-5" style={{overflow:'hidden'}}>
									<label>Website & Email</label>
									<div>
										<a href={decode(result?.website)}>{decode(result?.website)}</a><br/>
										<a href={`mailto:${result?.email}`}>{result?.email}</a><br/>
									</div>
								</div>

								
							  </div>


								<div className="list-action-wrpr showicons roundicons-text">
										<div className="list-action-wrpr">
											<Link  to={"/edit_school/"+id} data-toggle="tooltip" title="Edit">
												<i className="edit icon-pencil3"></i>
												<span>Update</span>
											</Link>

											{urole === "HO_SCHOOL" || urole === "ATHLETIC_MANAGER"?null:
											<button data-toggle="tooltip" className="delteprof" title="Delete" id={id}
												onClick={ ()=> { removeAccreditations(id) } }
											>
											
												<i className="delete icon-close1"></i>
												<span>Delete</span>
											</button>
											}
										</div>
									</div>


							</div>
						 
						

						<div id="characteristics" className="containers tab-pane"><br/>
						 
							<div className="row tab-section">
							<div className="col-md-4">
								<label>Founding Date</label>
								<div>{result?.founding_date ? result?.founding_date : "-"}</div>
							</div>
							<div className="col-md-4">
								<label>Denomination</label>
								<div>{result?.denomination ? result?.denomination : '-'}</div>
							</div>
							<div className="col-md-4">
								<label>Enrollment</label>
								<div>{result?.enrollment ? result?.enrollment : '-'}</div>
							</div>
						  </div>
						  
						  <div className="row tab-section">
							<div className="col-md-4">
								<label>Grade Levels</label>
								<div>{result?.grade_level}</div>
							</div>
							<div className="col-md-4">
								<label>Gender</label>
								<div>{result?.gender}</div>
							</div>
							<div className="col-md-4">
								<label>Day/Boarding</label>
								<div>{result?.day_boarding}</div>
							</div>
						  </div>
						  
						
						<div className="row tab-section">
							<div className="col-md-4">
								<label>InterScholastic</label>
								<div>{result?.interscholastic}</div>
							</div>
							<div className="col-md-4">
								<label>Country</label>
								<div>{result?.county?.name}</div>
							</div>
							<div className="col-md-4">
								<label>Accreditation</label>
								<div>
									{result?.accreditation?.name}
								</div>
							</div>
						</div>

							
						
						
				</div>
				</div>

				


				</div>
			</div>					
        </aside>
    </div>
    );
}

export default SchoolProfile